module.exports = __webpack_public_path__ + "img/落地通风柜.9bb1e0de.jpg";